import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, GraduationCap, CalendarHeart, Wallet, FileSignature,
  Users, LogOut, Menu, X, BookOpen, ClipboardList, CalendarClock, FileCheck2, QrCode,
  UtensilsCrossed, AlertTriangle, BookOpenCheck, Clock, Landmark,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Notificaciones } from "@/components/Notificaciones";
import { AdminNav } from "@/components/NavAdmin";
import { iniciales } from "@/lib/format";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";

const navPadres = [
  { to: "/portal", label: "Inicio", icon: LayoutDashboard, tid: "nav-inicio" },
  { to: "/portal/academico", label: "Académico", icon: GraduationCap, tid: "nav-academico" },
  { to: "/portal/horario", label: "Horario de clases", icon: CalendarClock, tid: "nav-horario" },
  { to: "/portal/menu", label: "Menú escolar", icon: UtensilsCrossed, tid: "nav-menu" },
  { to: "/portal/actividades", label: "Actividades", icon: CalendarHeart, tid: "nav-actividades" },
  { to: "/portal/finanzas", label: "Financiero", icon: Wallet, tid: "nav-finanzas" },
  { to: "/portal/documentos", label: "Documentos", icon: FileSignature, tid: "nav-documentos" },
  { to: "/portal/manual", label: "Manual de uso", icon: BookOpenCheck, tid: "nav-manual" },
];

const navDocente = [
  { to: "/docente", label: "Mis materias", icon: BookOpen, tid: "nav-docente-materias" },
  { to: "/docente/ponche", label: "Ponchador", icon: Clock, tid: "nav-docente-ponche" },
  { to: "/docente/mis-pagos", label: "Mis pagos de nómina", icon: Landmark, tid: "nav-docente-mis-pagos" },
  { to: "/docente/horario", label: "Mi horario de clases", icon: CalendarClock, tid: "nav-docente-horario" },
  { to: "/docente/planificacion", label: "Mi planificación", icon: FileCheck2, tid: "nav-docente-planificacion" },
  { to: "/docente/tareas", label: "Tareas y actividades", icon: ClipboardList, tid: "nav-docente-tareas" },
  { to: "/docente/classroom", label: "Google Classroom", icon: GraduationCap, tid: "nav-docente-classroom" },
  { to: "/docente/estudiantes", label: "Estudiantes", icon: Users, tid: "nav-docente-estudiantes" },
  { to: "/docente/manual", label: "Manual de uso", icon: BookOpenCheck, tid: "nav-docente-manual" },
];

const navCoordinacion = [
  { to: "/coordinacion", label: "Resumen", icon: LayoutDashboard, tid: "nav-coord-resumen" },
  { to: "/coordinacion/docentes", label: "Docentes", icon: GraduationCap, tid: "nav-coord-docentes" },
  { to: "/coordinacion/planificaciones", label: "Planificaciones", icon: FileCheck2, tid: "nav-coord-planificaciones" },
  { to: "/coordinacion/horarios", label: "Horario de clases", icon: CalendarClock, tid: "nav-coord-horarios" },
  { to: "/coordinacion/tareas", label: "Actividades docentes", icon: ClipboardList, tid: "nav-coord-tareas" },
  { to: "/coordinacion/estudiantes", label: "Estudiantes", icon: Users, tid: "nav-coord-estudiantes" },
  { to: "/coordinacion/alertas", label: "Alertas de rendimiento", icon: AlertTriangle, tid: "nav-coord-alertas" },
  { to: "/coordinacion/materias", label: "Materias", icon: BookOpen, tid: "nav-coord-materias" },
  { to: "/coordinacion/registro-docentes", label: "Registro de docentes", icon: QrCode, tid: "nav-coord-registro" },
  { to: "/coordinacion/mis-pagos", label: "Mis pagos de nómina", icon: Landmark, tid: "nav-coord-mis-pagos" },
  { to: "/coordinacion/manual", label: "Manual de uso", icon: BookOpenCheck, tid: "nav-coord-manual" },
];
export const Layout = ({ admin = false, docente = false, coord = false }) => {
  const { user, logout, estudiantes, activeStudent, selectStudent, config } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const items = docente ? navDocente : coord ? navCoordinacion : navPadres;
  const subtitulo = docente ? "Portal de docentes"
    : admin ? (user?.rol === "secretaria" ? "Panel de secretaría"
      : user?.rol === "superadmin" ? "Panel SuperAdmin" : "Panel administrativo")
    : coord ? "Portal de coordinación" : "Portal de padres y tutores";

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  const NavItems = ({ onClick }) => (
    admin ? <AdminNav onNavigate={onClick} /> : (
    <nav className="flex flex-col gap-1">
      {items.map((i) => (
        <NavLink
          key={i.to}
          to={i.to}
          end={i.to === "/portal" || i.to === "/admin" || i.to === "/docente" || i.to === "/coordinacion"}
          onClick={onClick}
          data-testid={i.tid}
          className={({ isActive }) =>
            `flex items-center gap-3 rounded-md px-4 py-3 text-sm lift ${
              isActive
                ? "bg-primary text-primary-foreground font-semibold"
                : "text-muted-foreground hover:bg-muted hover:text-foreground"
            }`
          }>
          <i.icon className="h-4 w-4 shrink-0" />
          {i.label}
        </NavLink>
      ))}
    </nav>
    )
  );

  return (
    <div className="min-h-screen bg-background">
      <header className="glass sticky top-0 z-40 border-b border-border">
        <div className="mx-auto flex max-w-[1500px] items-center gap-4 px-4 py-3 sm:px-8">
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden rounded-md p-2 hover:bg-muted"
            onClick={() => setOpen(!open)}>
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>

          <div className="flex min-w-0 items-center gap-3">
            <img
              src={config.tiene_logo
                ? `${API}/configuracion/imagen/logo?v=${config.imagen_version}`
                : "https://customer-assets-cm19k8pv.emergentagent.net/job_school-hub-1220/artifacts/eggcq1ix_302319671_479406710859175_2268986965834108785_n.jpg"}
              alt={config.nombre}
              className="h-11 w-auto shrink-0 object-contain sm:h-12"
              data-testid="brand-logo"
            />
            <div className="hidden leading-tight min-w-0 sm:block">
              <p className="font-display text-sm font-extrabold tracking-tight sm:text-base">
                {config.nombre}
              </p>
              <p className="hidden text-xs text-muted-foreground sm:block">
                {subtitulo} · {config.anio_lectivo}
              </p>
            </div>
          </div>

          <div className="ml-auto flex min-w-0 items-center gap-2 sm:gap-3">
            {!admin && !docente && !coord && estudiantes.length > 0 && (              <div className="flex items-center gap-2 rounded-full border border-border bg-card p-1 pr-3">
                <div className="hidden sm:flex items-center gap-1" data-testid="student-selector">
                  {estudiantes.map((e) => (
                    <button
                      key={e.id}
                      data-testid={`student-chip-${e.matricula}`}
                      onClick={() => selectStudent(e.id)}
                      className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-sm lift ${
                        activeStudent?.id === e.id
                          ? "bg-secondary text-secondary-foreground font-semibold"
                          : "text-muted-foreground hover:bg-muted"
                      }`}>
                      <span className="grid h-6 w-6 place-items-center rounded-full bg-primary/10 text-[10px] font-bold text-primary">
                        {iniciales(e.nombre)}
                      </span>
                      {e.nombre.split(" ")[0]}
                    </button>
                  ))}
                </div>
                <select
                  data-testid="student-selector-mobile"
                  className="sm:hidden bg-transparent text-sm outline-none"
                  value={activeStudent?.id || ""}
                  onChange={(ev) => selectStudent(ev.target.value)}>
                  {estudiantes.map((e) => (
                    <option key={e.id} value={e.id}>{e.nombre}</option>
                  ))}
                </select>
              </div>
            )}
            <div className="hidden md:block text-right">
              <p className="text-sm font-semibold">{user?.nombre}</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{user?.rol}</p>
            </div>
            {user?.rol === "tutor" && <Notificaciones />}
            {["superadmin", "admin", "docente", "coordinadora", "secretaria"].includes(user?.rol) && <Notificaciones />}
            <Button variant="ghost" size="icon" onClick={doLogout} data-testid="logout-button" title="Cerrar sesión">              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>

      <div className="mx-auto flex max-w-[1500px] gap-8 px-4 py-8 sm:px-8">
        <aside className="hidden w-60 shrink-0 lg:block">
          <div className="sticky top-24 max-h-[calc(100vh-8rem)] overflow-y-auto pb-6">
            <NavItems />
            {!admin && !docente && !coord && (
              <p className="mt-8 px-4 text-xs leading-relaxed text-muted-foreground">
                ¿Dudas con su estado de cuenta? Escriba a administracion@chikigenios.edu.do
              </p>
            )}
          </div>
        </aside>

        {open && (
          <div className="fixed inset-0 z-[60] bg-foreground/40 lg:hidden" onClick={() => setOpen(false)}>
            <div className="h-full w-64 overflow-y-auto bg-card p-4" onClick={(e) => e.stopPropagation()}>
              <div className="mb-4 flex items-center justify-between">
                <p className="font-display text-sm font-bold">Menú</p>
                <button onClick={() => setOpen(false)} className="rounded-md p-2 hover:bg-muted"
                        data-testid="cerrar-menu-movil">
                  <X className="h-4 w-4" />
                </button>
              </div>
              <NavItems onClick={() => setOpen(false)} />
            </div>
          </div>
        )}

        <main className="min-w-0 flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
